import React from 'react'
import { Button, Checkbox, Form } from 'antd'
import { strVal } from '../../../../modules/Utils'
import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import CustomTable from '../../../../elements/Table/CustomTable'
import { compose } from 'recompose'

function Permissions(props) {
  const { fetch, loading, updating, company, submit, data } = props
  const columns = [
    {
      Header: 'Process',
      accessor: 'rule',
      Cell: ({ value }) => value.toUpperCase(),
    },
    {
      Header: 'Department',
      accessor: 'department',
      Cell: ({ value }) => strVal({ value }, 'value').toUpperCase(),
    },
    {
      Header: (
        <Checkbox
          indeterminate={props['menu'].indeterminate}
          checked={props['menu'].column}
          onChange={(e) => props.onColumnChange(e, 'menu')}>
          Menu (Sidebar)
        </Checkbox>
      ),
      accessor: 'menu',
      Cell: ({ value, original }) => (
        <Checkbox checked={value} onChange={(e) => props.onCellChange(e, original.rule, 'menu')} />
      ),
    },
    {
      Header: (
        <Checkbox
          indeterminate={props['read'].indeterminate}
          checked={props['read'].column}
          onChange={(e) => props.onColumnChange(e, 'read')}>
          Read
        </Checkbox>
      ),
      accessor: 'read',
      Cell: ({ value, original }) => (
        <Checkbox checked={value} onChange={(e) => props.onCellChange(e, original.rule, 'read')} />
      ),
    },
    {
      Header: (
        <Checkbox
          indeterminate={props['write'].indeterminate}
          checked={props['write'].column}
          onChange={(e) => props.onColumnChange(e, 'write')}>
          Write
        </Checkbox>
      ),
      accessor: 'write',
      hideable: true,
      hideText: 'Write',
      Cell: ({ value, original }) => (
        <Checkbox checked={value} onChange={(e) => props.onCellChange(e, original.rule, 'write')} />
      ),
    },
    {
      Header: (
        <Checkbox
          indeterminate={props['stamp'].indeterminate}
          checked={props['stamp'].column}
          onChange={(e) => props.onColumnChange(e, 'stamp')}>
          Stamp
        </Checkbox>
      ),
      accessor: 'stamp',
      Cell: ({ value, original }) => (
        <Checkbox checked={value} onChange={(e) => props.onCellChange(e, original.rule, 'stamp')} />
      ),
    },
  ]
  return (
    <Form rowKey={'rule'}>
      <CustomTable
        isFilterable={true}
        show={{ extraColumns: true }}
        CreateButton={() => (
          <OrganisationsSelect value={company} size={'small'} style={{ width: '50%' }} onChange={fetch} />
        )}
        fetch={() => fetch(company)}
        columns={columns}
        data={data}
        fetching={loading}
      />
      <Button onClick={submit} style={{ marginTop: 20 }} loading={updating} type="primary" htmlType="submit">
        Update
      </Button>
    </Form>
  )
}

export default compose(Form.create())(Permissions)
